export type QueryValue =
    string
    | number
    | boolean
    | null
    | undefined
    | Array<string | number | boolean | null | undefined>
    | Record<string, any>;
export type Query = Record<string, QueryValue>;
export type JsonPrimitive = string | number | boolean | null;
export type JsonArray = JsonValue[];
export type JsonObject = { [key: string]: JsonValue };
export type JsonValue = JsonPrimitive | JsonObject | JsonArray;
export type BodyRequest = JsonValue | FormData | Record<string, any>;

type Segment = string | number | boolean;

export class UrlUtils {
    private url: string;
    private segments: string[] = [];
    private query: Query = {};

    constructor(url: string) {
        this.url = url;
        this.reset()
    }

    static instance(url: string): UrlUtils {
        return new UrlUtils(url);
    }

    addSegment(segment: Segment, value?: Segment): UrlUtils {
        this.segments.push(segment.toString());
        if (value !== undefined) {
            this.segments.push(value.toString());
        }
        return this;
    }

    addQuery(query?: Query): UrlUtils {
        if(query) {
            this.query = {
                ...this.query,
                ...query
            };
        }
        return this;
    }

    generateURL(segment?: Segment[] | Segment, quey?: Query): string{
        if (segment) {
            if (Array.isArray(segment)) {
                segment.forEach((seg: Segment) => this.addSegment(seg));
            } else {
                this.addSegment(segment);
            }
        }
        const segments: string = this.generateSegments();
        const query: string = this.generateQuery();
        this.reset()
        return this.addSlashIfNeeded(this.url, segments) + (query ? `?${ query }` : '');
    }

    private addSlashIfNeeded(url: string, segment: string = ''): string {
        if (url.slice(-1) !== '/' && segment.slice(0, 1) !== '/') {
            url += '/';
        }
        return url + segment;
    }

    private generateSegments(): string {
        let segments: string = '';
        this.segments.forEach((segment: string) => {
            segments = this.addSlashIfNeeded(segments, segment);
        });
        return segments;
    }

    private reset(): void {
        this.segments = [];
        this.query = {};
    }

    /**
     * Esta implementação revisada lida corretamente com arrays no formato `key[]=value1&key[]=value2`,
     * mantendo a capacidade de lidar com objetos aninhados e outros tipos de valores.
     * @private
     */
    private generateQuery(): string {
        const params = new URLSearchParams();

        const addParam = (key: string, value: any) => {
            if (value === null || value === undefined) {
                params.append(key, '');
                return;
            }

            if (Array.isArray(value)) {
                value.forEach(item => addParam(`${key}[]`, item));
            } else if (typeof value === 'object') {
                Object.entries(value).forEach(([subKey, subValue]) => {
                    addParam(`${key}[${subKey}]`, subValue);
                });
            } else {
                params.append(key, String(value));
            }
        };

        Object.entries(this.query).forEach(([key, value]) =>
            addParam(key, value)
        );

        return params.toString();
    }
}
